function getConnectionReason(aCorrelation, aEnrollee, aMatchEnrollee) {
    if (!aEnrollee || !aMatchEnrollee) {
        return "fail";
    }

    var lTimeZone = getDataItem(aEnrollee.TimeZoneId, 'TimeZone');
    var lStartDate = displayEnrolleeTimeZone(aCorrelation.StartDateUTC, lTimeZone);
    var lEndDate = displayEnrolleeTimeZone(aCorrelation.EndDateUTC, lTimeZone);
    var lMatchEnrollee = aMatchEnrollee;

    var lReturnString = "At this address with ";

    lReturnString += lMatchEnrollee.FirstName;
    lReturnString += " ";
    lReturnString += lMatchEnrollee.LastName;
    lReturnString += " (";
    lReturnString += lMatchEnrollee.PrimaryId;
    lReturnString += ") ";
    lReturnString += "from ";
    lReturnString += lStartDate;
    lReturnString += " to ";
    lReturnString += lEndDate;

    return lReturnString;
}
if (typeof exports !== 'undefined') {
    module.exports = getConnectionReason;
}